import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ProjectCategoryActions from './project-category.actions';
import { ProjectCategoryService } from '../../services/project-category.service';

@Injectable()
export class ProjectCategoryEffects {
  loadProjectCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectCategoryActions.loadProjectCategory),
      exhaustMap((_) =>
        this.projectCategoryService.getProjectCategory().pipe(
          map((data) =>
            ProjectCategoryActions.loadProjectCategorySuccess({
              projectCategory: data,
            })
          ),
          catchError((error) =>
            of(ProjectCategoryActions.loadProjectCategoryFailure({ error }))
          )
        )
      )
    )
  );

  addProjectCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectCategoryActions.addProjectCategory),
      concatMap(({ newProjectCategory }) =>
        this.projectCategoryService
          .createProjectCategory(newProjectCategory)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ProjectCategoryActions.addProjectCategorySuccess({
                newProjectCategory: data,
              });
            }),
            catchError((error) =>
              of(
                ProjectCategoryActions.addProjectCategoryFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateProjectCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectCategoryActions.updateProjectCategory),
      map((action) => action.updateProjectCategory),
      concatMap((updateProjectCategory) =>
        this.projectCategoryService
          .updateProjectCategory(updateProjectCategory)
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return ProjectCategoryActions.updateProjectCategorySuccess({
                updateProjectCategory: updateProjectCategory,
              });
            }),
            catchError((error) =>
              of(
                ProjectCategoryActions.updateProjectCategoryFailure({
                  error: error.message,
                })
              )
            )
          )
      )
    )
  );

  removeProjectCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectCategoryActions.removeProjectCategory),
      map((action) => action.ids),
      concatMap((ids) =>
        this.projectCategoryService.deleteProjectCategory(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ProjectCategoryActions.removeProjectCategorySuccess({ ids });
          }),
          catchError((error) =>
            of(
              ProjectCategoryActions.updateProjectCategoryFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private projectCategoryService: ProjectCategoryService,
    private notification: NotificationService
  ) {}
}
